<template lang="pug">
  .answers-card__header
    .answers-card-user
      .answers-card-user__avatar(
        :style="{backgroundImage: `url('${user.avatar}')`}"
      )
        | {{user.email[0]}}
      .answers-card-user__info
        .answers-card-user__name(v-if="username")
          | {{username}}
        p.answers-card-user__email
          | {{user.email}}
      .answers-card-user__tariff(
        v-if="userTariff"
        :style="{backgroundColor: '#'+userTariff.color}"
      )
        p {{userTariff.name}}

    .answers-card-company
      .answers-card-company__item(v-if="user.businessInfo")
        p
          | Бизнес участника:
          span.answers-card-company__item-value
            |  {{user.businessInfo}}

      .answers-card-company__item(v-if="user.niche")
        p
          | Ниша:
          span.answers-card-company__item-value
            |  {{user.niche}}

      .answers-card-company__item(v-if="user.profitPerWeek")
        p
          | Прибыль в неделю:
          span.answers-card-company__item-value  {{user.profitPerWeek | numberFormat}} р

</template>

<script>
export default {
  props: {
    user: {},
    tariffs: {}
  },
  computed: {
    username() {
      if (!this.user.name && !this.user.lastname) {
        return;
      }

      let name = '';
      if (this.user.name) {
        name += this.user.name + ' ';
      }

      if (this.user.lastname) {
        name += this.user.lastname;
      }

      return name;
    },
    userTariff() {
      if (!this.user.tariffId && this.tariffs.length === 0) {
        return;
      }

      return this.tariffs.find(t => t.id === this.user.tariffId);
    }
  }
};
</script>
